<app-page-header [heading]="'Temporary Sales'" [icon]="'fa-list'" style="height:100px;"></app-page-header>
<div class="page-panel">
  <div class="col-lg-12 row container">
    <div class="col-lg-8"></div>
    <div class="col-lg-4">
      <div class="row">
        <div class="input-group ">
          <input (keydown)="keyDownFunction($event)" [(ngModel)]="sale.search_sale" class="form-control"
                 id="typeahead-http" name="search_text"
                 placeholder="Customer Name..." style="height:31px" type="text">
          <div class="input-group-append">
            <button (click)="clear_search()" class="input-group-text" style="height:31px;padding:7px">
              <i *ngIf="sale.search_sale != ''" class="fa fa-close"></i>
              <i *ngIf="sale.search_sale == ''" class="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div *ngIf="this.status == 'Failed'"><span [hidden]="this.status == 'Success'"
                                                   style="color:red;font-size:13px;"> Sorry, suggestions could not be loaded.</span>
        </div>
        <div class="pull-right">
          <a class="btn  btn-success btn-sm ng-star-inserted" routerLink="/temp-sale/add-temp-sale"
             title="Create new temporary sale">&nbsp;<i
            class="fa fa-plus text-white"></i>&nbsp;</a>&nbsp;&nbsp;
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
  <div class="text-center">
    <button (click)="mergeInvoice(copydata);listCustomer()" class="btn btn-sm btn-primary" style="font-size: 12px;">
      Merge Invoice
    </button>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
  </div>
  <div class="">
    <table class="table tbl table-hover table-striped table-bordered">
      <thead>
      <tr class="text-center">
        <th width="1%"></th>
        <th width="1%">Sl#</th>
        <th>Customer Name</th>
        <th width=10%>Sale Date</th>
        <th>Location</th>
        <th width=10%>Invoice Number</th>
        <th width=10%>Invoice Date</th>
        <th width=10%>Total Amount</th>
        <th width=12%>Action</th>
      </tr>
      <tr *ngIf="(sale_data | json) == '[]'">
        <td class="text-center" colspan="10">No data to list</td>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let sale of sale_data;let i=index" style="font-size: 12px">
        <td class="text-center">
          <input (change)="updateChecked(i,sale.TEMP_SALE_ID)" [hidden]="sale.MOVE_TO_LIVE_INVOICE == 1"
                 name="check"
                 type="checkbox"
                 value="{{sale.CHECKED}}"/>
        </td>
        <td [class.text-success]="sale.MOVE_TO_LIVE_INVOICE == 1" class="text-center">
          {{ i + 1 }}
        </td>
        <td [class.text-success]="sale.MOVE_TO_LIVE_INVOICE == 1">
          {{ sale.PATIENT_NAME }}
        </td>
        <td [class.text-success]="sale.MOVE_TO_LIVE_INVOICE == 1" class="text-center">
          {{ utils.date(sale.SALE_DATE) }}
        </td>
        <td [class.text-success]="sale.MOVE_TO_LIVE_INVOICE == 1" class="text-center">
          {{ sale.STATE_NAME }}
        </td>
        <td [class.text-success]="sale.MOVE_TO_LIVE_INVOICE == 1" class="text-center">
          {{ sale.INVOICE_NUMBER }}
        </td>
        <td [class.text-success]="sale.MOVE_TO_LIVE_INVOICE == 1" class="text-center">
          {{ sale.INVOICE_DATE }}
        </td>
        <td [class.text-success]="sale.MOVE_TO_LIVE_INVOICE == 1" class="text-center">
          {{ round((sale.TOTAL_AMOUNT) - sale.DISCOUNT) }}
        </td>
        <td [class.text-success]="sale.MOVE_TO_LIVE_INVOICE == 1" class="text-center">
          <button (click)="sale_items(sale.TEMP_SALE_ID);open(content);" alt="View"
                  class="btn btn-xs btn-margin btn-info" style="font-size:12px"
                  title="View"><i class="fa fa-eye"></i></button>
          <ng-container *ngIf="sale.MOVE_TO_LIVE_INVOICE == 0">
            &nbsp;&nbsp;<a alt="Edit" class="btn btn-xs btn-margin btn-info"
                           routerLink="/temp-sale/add-temp-sale/edit/{{sale.TEMP_SALE_ID}}" style="font-size:12px;"
                           title="Edit"><i class="fa fa-edit"></i></a>
            &nbsp;&nbsp;<button (click)="open_copy(copydata);getSale(sale.TEMP_SALE_ID);listCustomer()"
                                alt="Move to live invoice" class="btn btn-xs btn-margin btn-info"
                                style="font-size:12px;"
                                title="Move to live invoice"><i
            class="fa fa-arrows"></i></button>
          </ng-container>
        </td>
      </tr>
      </tbody>
    </table>
    <app-pagination (pageChange)="listTemporarySale($event)" [pageSize]="p" [page]="page" [recordCount]="collection"/>
  </div>
</div>


<ng-template #content let-modal>
  <div class="modal-header">
    <div class="pull-right">
      <h3 class="modal-title" id="modal-basic-title">
        Particular List
      </h3>
    </div>
    <div class="pull-right text-right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div id="printInvoice">
          <div class="header-space">&nbsp;</div>
          <div class="header col-md-12">
            <div class="col-md-4 pull-left">
              <ng-container *ngIf="institution.INSTITUTION_LOGO">
                <img alt="" height="150" ngSrc="{{logo_path+institution.INSTITUTION_LOGO}}" width="150">
              </ng-container>
            </div>
            <div class="col-md-8 pull-right text-right" style="padding-right: 0;">
              <ng-container *ngIf="institution">
                <h5 class="name"><b>{{ institution.INSTITUTION_NAME }}</b></h5>
                <div style="line-height: 0.5em;"><label>{{ institution.INSTITUTION_ADDRESS }}</label></div>
                <div style="line-height: 0.5em;"><label>{{ institution.INSTITUTION_CITY }}
                  ,&nbsp;{{ institution.INSTITUTION_COUNTRY_NAME }}</label></div>
                <div style="line-height: 0.5em;"><label>Ph :&nbsp;{{ institution.INSTITUTION_PHONE_NO }}</label></div>
                <div style="line-height: 0.5em;"><label>Email :&nbsp;{{ institution.INSTITUTION_EMAIL }}</label></div>
                <div style="line-height: 0.5em;"><label>VAT
                  IN&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.INSTITUTION_VAT_NO }}</label>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="clearfix"></div>
          <h5 class="text-center">TAX INVOICE</h5>
          <br>
          <div>&nbsp;</div>
          <div *ngIf="saled" class="col-lg-12">
            <div class="col-8 pull-left " style="padding-left: 0;">
              <div *ngIf="saled.PATIENT_NAME" class="row">
                <div class="col-1">
                  <label> Customer&nbsp;&nbsp;</label>
                </div>
                <div class="col-11">
                  <label> : &nbsp;&nbsp;{{ saled.CUSTOMER_NAME }}
                    <ng-container *ngIf="saled.CUSTOMER_ADDRESS">,{{ saled.CUSTOMER_ADDRESS }}</ng-container>
                    <ng-container *ngIf="saled.CUSTOMER_PHONE">,{{ saled.CUSTOMER_PHONE }}</ng-container>
                  </label>
                </div>
              </div>
              <div *ngIf="saled.VAT_NO" class="row">
                <div class="col-12">
                  <label> VAT No&nbsp;&nbsp;</label>
                  <label> : &nbsp;&nbsp;{{ saled.VAT_NO }}</label>
                </div>
              </div>
              <div *ngIf="saled.PAYMENT_TYPE" class="row">
                <div class="col-12">
                  <label>Payment Type&nbsp;&nbsp;</label>
                  <label class="text-left">
                    <ng-container *ngIf="saled.PAYMENT_TYPE == 1">:&nbsp;&nbsp; Cash</ng-container>
                    <ng-container *ngIf="saled.PAYMENT_TYPE == 0">:&nbsp;&nbsp; Card</ng-container>
                    <ng-container *ngIf="saled.PAYMENT_TYPE == 2">:&nbsp;&nbsp; Cheque</ng-container>
                    <ng-container *ngIf="saled.PAYMENT_TYPE == 3">:&nbsp;&nbsp; Bank</ng-container>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-3 pull-right text-right" style="padding-right: 0;">

              <div *ngIf="saled.INVOICE_NUMBER"><label> Invoice No&nbsp;&nbsp; :&nbsp;
                &nbsp;&nbsp;{{ saled.INVOICE_NUMBER }}</label></div>
              <div *ngIf="saled.SALE_DATE"><label> Invoice Date
                &nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;{{ utils.date(saled.SALE_DATE) }}</label></div>
            </div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <table class=" container  col-md-12 printtable">
              <thead>
              <tr style="border-bottom: 1px solid #000;border-top: 1px solid #000;">

                <th class="text-left" width="3%">#</th>
                <th class="text-left">Item</th>
                <th class="text-left">Warehouse</th>
                <th class="text-left" width="9%">HSN Code</th>
                <th class="text-center" width="6%">MRP</th>
                <th class="text-center" width="6%">Rate</th>
                <th class="text-center" width="4%">Qty</th>
                <th class="text-center" width="5%">UOM</th>
                <th class="text-center" width="6%">Price</th>
                <th class="text-center" width="6%">VAT %</th>
                <th class="text-center" width="7%">VAT Amt</th>
                <th class="text-center" width="6%">F. Cess</th>
                <th class="text-right" width="6%">Total</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of item_list;let i=index">
                <td class="text-left">{{ i + 1 }}</td>
                <td class="text-left"> {{ item.TRADE_NAME }}
                  <ng-container *ngIf="item.MARK_FOC == 1">&nbsp;(Freebie)</ng-container>
                </td>
                <td class="text-left">{{ item.WAREHOUSE_NAME }}</td>
                <td class="text-left">{{ item.HSN_CODE }}</td>
                <td class="text-center">{{ item.MRP }}</td>
                <td class="text-center">{{ item.UNIT_PRICE }}</td>
                <td class="text-center">{{ item.QUANTITY }}</td>
                <td class="text-center">{{ item.SHORT_FORM }}</td>
                <td class="text-center">{{ item.PRICE }}</td>
                <ng-container *ngIf="saled">
                  <td class="text-center">{{ item.VAT }}</td>
                </ng-container>
                <td class="text-center">{{ item.VAT_AMOUNT }}</td>
                <td class="text-center">{{ item.FLOOD_CESS }}</td>
                <td class="text-right">{{ item.TOTAL }}</td>
              </tr>
              <tr style="border-bottom: 1px solid #000;"></tr>
              </tbody>
            </table>
            <div class="clearfix">&nbsp;</div>
            <div class="clearfix">&nbsp;</div>
            <div class="clearfix">&nbsp;</div>
            <div class="clearfix">&nbsp;</div>
            <div *ngIf="saled" class="  col-md-12" style="text-align:right;border-top: 1px solid #000;">
              Gross amount&nbsp;&nbsp;: &nbsp;&nbsp;{{ gross | number : '1.2-2' }}
              <ng-container *ngIf="saled && saled.DISCOUNT > 0">
                <br>
                Discount &nbsp;&nbsp;:&nbsp;&nbsp; {{ saled.DISCOUNT }}
              </ng-container>
              <ng-container *ngIf="saled && saled.FREIGHT_CHARGE > 0">
                <br>
                Frieght/Handling charge &nbsp;&nbsp;:&nbsp;&nbsp; {{ saled.FREIGHT_CHARGE }}
              </ng-container>
            </div>
            <div class=" col-md-12"
                 style="text-align:right;font-weight: bolder;font-size:18px;border-bottom-style:double;border-top-style:double;">
              Net bill amount : {{ price_total | number : '1.2-2' }}
            </div>
            <div class="clearfix"></div>
            <div class=" col-md-12">
              <span>Amount in words &nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;</span>
              <span style="text-transform:capitalize;">&nbsp;{{ numberToWords }} &nbsp;Rupees only </span>
              <div *ngIf="save_rate > 0" class="pull-right text-right">You saved Rs {{ save_rate }}/-</div>
            </div>
            <div class="  col-md-12 clearfix" style="border-bottom: 1px solid #000"></div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <div class="clearfix"></div>
            <table style="width: 100%;">
              <tr>
                <td style="width: 70%;vertical-align: top;">
                  <table class="table table-bordered vat" style="width: 100%;">
                    <tr class="text-center">
                      <th width="3%">VAT %</th>
                      <th width="10%">Taxable value</th>
                      <ng-container>
                        <th class="text-center">VAT <br>
                          <span class="pull-left">&nbsp;&nbsp;&nbsp;%</span>
                          <span class="pull-right">Amount&nbsp;&nbsp;&nbsp;</span>
                        </th>
                      </ng-container>
                      <th class="text-center">Flood Cess <br>
                        <span class="pull-left">&nbsp;&nbsp;&nbsp;%</span>
                        <span class="pull-right">Amount&nbsp;&nbsp;&nbsp;</span>
                      </th>
                    </tr>
                    <tr *ngFor="let tax of vat_list">
                      <td class="text-center">{{ tax.VAT }}</td>
                      <td class="text-center">{{ (tax.TAXABLE_VALUE)| number : '1.2-2' }}</td>
                      <ng-container>
                        <td width="6%">
                          <label class="pull-left">{{ tax.VAT }}</label>
                          <label class="pull-right">{{ (tax.VAT_VALUE)| number : '1.2-2' }}</label>
                        </td>
                      </ng-container>
                      <td width="6%">
                        <label class="pull-left">1.00</label>
                        <label class="pull-right">{{ (tax.FLOOD_CESS)| number : '1.2-2' }}</label>
                      </td>
                    </tr>
                  </table>
                </td>
                <td style="width: 30%;vertical-align: top;">
                  <table class="table table-bordered vat" style="width: 100%;">
                    <ng-container>
                      <tr>
                        <th>VAT</th>
                        <th class="text-right"> {{ total_vat | number : '1.2-2' }}</th>
                      </tr>
                    </ng-container>
                    <tr>
                      <th>Flood Cess</th>
                      <th class="text-right"> {{ total_flood | number : '1.2-2' }}</th>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #copydata let-modal>
  <div class="modal-header">
    <div class="pull-right ">
      <h3 id="modal-basic-title">
        Move to live Invoice
      </h3>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="tab-pane active">
      <div class="tab-content">
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <ng-template #rt let-r="result" let-t="term">
          <ngb-highlight [result]="r.HSN_CODE+'  '+r.DDC_CODE+' - '+r.TRADE_NAME" [term]="t"></ngb-highlight>
        </ng-template>
        <div *ngIf="user_rights.ADD == '1'" class="page-panel">
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="row">
            <div class="form-group col-lg-3">
              <label>Customer Name</label><span class="text-danger">&nbsp;*</span>
              <ngx-select-dropdown (change)="getCustomer()" [(ngModel)]="customer_data"
                                   [config]="utils.dropConfig({displayKey: 'CUSTOMER_NAME',placeholder: 'Select Customer',searchOnKey: 'CUSTOMER_NAME'})"
                                   [multiple]="false" [options]="customer_options"
                                   class="form-control  " name="customer"
                                   style="padding: 0;font-size: 12px;"></ngx-select-dropdown>
            </div>
            <div class="form-group col-lg-3">
              <label>Date</label><span class="text-danger">&nbsp;*</span>
              <input (ngModelChange)="sale.sale_date = $event" [max]="getToday()"
                     [ngModel]="sale.sale_date | date:'yyyy-MM-dd'"
                     class="form-control " id="date" name="date" type="date">
            </div>
            <div class="form-group col-lg-3">
              <label>Order No</label><span class="text-danger">&nbsp;*</span>
              <input [(ngModel)]="sale.order_no" class="form-control " maxlength="10" name="order_no"
                     readonly="readonly" tabindex="-1"
                     type="text">
            </div>
            <div class="form-group col-lg-3">
              <label>Location</label><span class="text-danger">&nbsp;*</span>
              <input [(ngModel)]="sale.state" [readOnly]="true" class="form-control " maxlength="10"
                     name="state" type="text">
            </div>
            <div class="form-group col-lg-3">
              <label>Payment Type</label>
              <div class="col-12">
                <label class="checkbox-inline">
                  <input (click)="selectCoinPaymentType(1)" [checked]="sale.payment_type == 1" id="cash"
                         name="payment_type" type="radio"
                         value="1">&nbsp;&nbsp;Cash&nbsp;&nbsp;
                </label>&nbsp;&nbsp;&nbsp;
                <label class="checkbox-inline">
                  <input (click)="selectCoinPaymentType(0)" [checked]="sale.payment_type == 0" id="card"
                         name="payment_type" type="radio"
                         value="0">&nbsp;&nbsp;Card&nbsp;&nbsp;
                </label>&nbsp;&nbsp;&nbsp;
                <label class="checkbox-inline">
                  <input (click)="selectCoinPaymentType(2)" [checked]="sale.payment_type==2" id="cheque"
                         name="payment_type" type="radio"
                         value="2">&nbsp;&nbsp;Cheque&nbsp;&nbsp;
                </label>
                <label class="checkbox-inline">
                  <input (click)="selectCoinPaymentType(3)" [checked]="sale.payment_type==3" id="bank"
                         name="payment_type" type="radio"
                         value="3">&nbsp;&nbsp;Bank
                </label>
              </div>
            </div>
            <div class="form-group col-lg-3">
              <label>Shipping Address</label>
              <textarea [(ngModel)]="sale.shipping_address" class="form-control " name="shipping_address"
                        style="font-size: 12px;"></textarea>
            </div>
            <div class="form-group col-lg-3">
              <label>Remarks</label>
              <input [(ngModel)]="sale.remark" class="form-control " name="remark" type="text">
            </div>
          </div>
          <hr>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="col-lg-12 ">
            <table class=" table   table-bordered">
              <thead>
              <tr class="text-center">
                <th>FOC</th>
                <th>#Sl</th>
                <th width="25%">Item Information<span class="text-danger">&nbsp;*</span></th>
                <th class="text-left">Warehouse<span class="text-danger">&nbsp;*</span></th>
                <th>Ava.Qty</th>
                <th width="8%">UOM</th>
                <th>MRP</th>
                <th>Retail Price</th>
                <th width="7%">Quantity<span class="text-danger">&nbsp;*</span></th>
                <ng-container>
                  <th colspan="2">VAT <span class="text-danger">&nbsp;*</span><br>
                    <span>%</span><span class="pull-right">Amount</span></th>
                </ng-container>
                <th>Total<span class="text-danger">&nbsp;*</span></th>
                <th>*</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let i of utils.buildArray(sale_details.length)">
                <td class="text-center">
                  <label>
                    <input (change)="giveMarkFOC(i)"
                           [(ngModel)]="sale.mark_free_of_cost[i]"
                           [checked]="sale.mark_free_of_cost[i] == true"
                           name="mark_free_of_cost{{i}}"
                           type="checkbox"/>
                  </label>
                </td>
                <td class="text-center">{{ 1 + i }}</td>
                <td>
                  <input (selectItem)="set_item_medicine($event,i)" [(ngModel)]="sale.medicine_data[i]"
                         [class.is-invalid]="searchFailed"
                         [inputFormatter]="formatter" [ngModelOptions]="{standalone: true}"
                         [ngbTypeahead]="medicine_search" [resultTemplate]="rt"
                         class="form-control" id="typeahead-http{{i}}"
                         placeholder="Search Particular Name...." style="height: 29px;"
                         type="text"/>
                </td>
                <td>
                  <select (change)="availableqty(i)" [(ngModel)]="sale.warehouse_details_id_arr[i]"
                          class="form-control  custom-select custom-select-sm"
                          name="warehouse_id">
                    <option value=''>Select Warehouse</option>
                    <option *ngFor="let data of sale.warehouses_data[i];"
                            value="{{data.WAREHOUSE_STOCK_DETAIL_ID}}">{{ data.WAREHOUSE }}
                    </option>
                  </select>
                </td>
                <td>
                  <input [(ngModel)]="sale.ava_quantity_arr[i]" [readOnly]="true"
                         class="form-control text-center "
                         name="ava_quantity_arr{{i}}" tabindex="-1" type="text">
                </td>
                <td>
                  <input [(ngModel)]="sale.uom_arr_name[i]" [readOnly]="true" class="form-control  "
                         name="uom_arr_name{{i}}" tabindex="-1" type="text">
                </td>
                <td>
                  <input [(ngModel)]="sale.MRP[i]" [readOnly]="true" class="form-control text-right "
                         name="MRP{{i}}" tabindex="-1" type="text">
                </td>
                <td>
                  <input (focusout)="totalAmount();totalprice();" [(ngModel)]="sale.unitprice_arr[i]"
                         [disabled]="sale.mark_free_of_cost[i] == true" class="form-control text-right "
                         name="unitprice_arr{{i}}" type="text">
                </td>
                <td>
                  <input (focusout)="totalprice();totalAmount()" [(ngModel)]="sale.quantity_arr[i]"
                         class="form-control  " maxlength="7" name="quantity_arr{{i}}" type="text">
                </td>
                <ng-container>
                  <td>
                    <input (focusout)="totalprice()" [(ngModel)]="sale.vat_arr[i]" [readOnly]="true"
                           class="form-control text-right " name="vat_arr{{i}}" tabindex="-1"
                           type="text">
                  </td>
                  <td>
                    <input (focusout)="totalprice()" [(ngModel)]="sale.vatamt_arr[i]" [readOnly]="true"
                           class="form-control text-right " name="vatamt_arr{{i}}" tabindex="-1"
                           type="text">
                  </td>
                </ng-container>
                <td>
                  <input [(ngModel)]="sale.total_arr[i]" [readOnly]="true"
                         class="form-control text-right "
                         name="total_arr{{i}}" tabindex="-1" type="text">
                </td>
                <td>
                  <button (click)="addrow(i)" *ngIf="i == sale_details.length-1" alt="Add New data"
                          class="btn btn-success btn-sm "
                          title="Add New data" type="button"><i class="fa fa-plus"
                                                                style="color: white;"></i>
                  </button>
                  <button (click)="deleterow(i)" *ngIf="i  != sale_details.length-1" alt="Delete data"
                          class="btn btn-danger  btn-sm "
                          title="Delete data" type="button"><i class="fa fa-trash"
                                                               style="color: white;"></i>
                  </button>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <ng-container>
                <tr>
                  <td colspan="13" style="text-align: right"><label>Gross Total&nbsp;&nbsp;&nbsp;</label></td>
                  <td style="text-align: right;width:10%"><label>{{ total_amount | number : '1.2-2' }}</label></td>
                </tr>
                <tr>
                  <td colspan="7" style="text-align: right"><label>Discount&nbsp;&nbsp;&nbsp; </label></td>
                  <input (focusout)="total()" [(ngModel)]="sale.discount"
                         class="form-control text-right "
                         maxlength="8" name="dis_arr" style="height:34px"
                         type="text">
                  <td colspan="2" style="text-align: right"><label>Freight/Handling charge&nbsp;&nbsp; </label></td>
                  <input (focusout)="total()" [(ngModel)]="sale.freight_charge"
                         class="form-control text-right "
                         maxlength="9" name="freight" style="height:34px" type="text">
                  <td colspan="2" style="text-align: right"><label>Net Total&nbsp;&nbsp;&nbsp;</label></td>
                  <td style="text-align: right;width:10%"><label>{{ net_total | number : '1.2-2' }}</label></td>
                </tr>
              </ng-container>
              <ng-container>
                <tr>
                  <td colspan="11" style="text-align: right"><label>Gross Total&nbsp;&nbsp;&nbsp;</label></td>
                  <td style="text-align: right;width:10%"><label>{{ total_amount | number : '1.2-2' }}</label></td>
                </tr>
                <tr>
                  <td colspan="6" style="text-align: right"><label>Discount&nbsp;&nbsp;&nbsp; </label></td>
                  <input (focusout)="total()" [(ngModel)]="sale.discount"
                         class="form-control text-right "
                         maxlength="8" name="dis_arr" style="height:34px"
                         type="text">
                  <td colspan="2" style="text-align: right"><label>Freight/Handling charge&nbsp;&nbsp; </label></td>
                  <input (focusout)="total()" [(ngModel)]="sale.freight_charge"
                         class="form-control text-right " maxlength="9"
                         name="freight" style="height:34px" type="text">
                  <td style="text-align: right"><label>Net Total&nbsp;&nbsp;&nbsp;</label></td>
                  <td style="text-align: right;width:10%"><label>{{ net_total | number : '1.2-2' }}</label></td>
                </tr>
              </ng-container>
              </tfoot>
            </table>
            <div class="clearfix"></div>
          </div>
          <div class="clearfix"></div>
          <div class="row container">
            <div class="col-lg-7 pull-right">
              <button (click)="saveSale()" class="btn  btn-info btn-sm ng-star-inserted" type="button">&nbsp;Move to
                Live&nbsp;
              </button>&nbsp;&nbsp;
            </div>
          </div>
          <div style="height:100px"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
